import {
  calculateZar8UnlockSummary,
  getZar8UnlockPositionLockedAmount,
} from "../utils/zar8LockFlow";
import { create, get } from "./apiService";

export const getZar8YieldPositions = (params = {}) =>
  get("api/v2/zar8/positions", params);

export const getZar8YieldPosition = (positionId) =>
  get(`api/v2/zar8/positions/${positionId}`);

export const getZar8YieldHistory = (params = {}) =>
  get("api/v2/zar8/yield/history", params);

export const getZar8YieldEarnings = () => get("api/v2/zar8/yield/earnings");

export const getZar8YieldConfig = () => get("api/v2/zar8/yield-config");

export const calculateZar8Yield = (params = {}) =>
  get("api/v2/zar8/yield/calculate", params);

export const createZar8YieldPosition = (payload) =>
  create("api/v2/zar8/positions", payload);

const MOCK_REQUEST_DELAY_MS = 250;

const resolveAfterDelay = (payload) =>
  new Promise((resolve) => {
    window.setTimeout(() => {
      resolve(payload);
    }, MOCK_REQUEST_DELAY_MS);
  });

export const createZar8UnlockQuote = async ({
  amountZar,
  selectedPosition,
}) => {
  const lockedAmountZar = getZar8UnlockPositionLockedAmount(selectedPosition);

  if (!selectedPosition) {
    throw new Error("Select an active yield term to continue.");
  }

  if (amountZar <= 0) {
    throw new Error("Enter a valid amount to continue.");
  }

  if (amountZar > lockedAmountZar) {
    throw new Error("Amount exceeds your locked ZAR8 balance.");
  }

  return resolveAfterDelay(
    calculateZar8UnlockSummary({
      amountZar,
      lockedAmountZar,
      feeType: selectedPosition.feeType,
      feeAmount: selectedPosition.feeAmount,
    })
  );
};

export const createZar8Unlock = async ({
  amountZar,
  selectedPosition,
  twoFactorToken,
  quote,
}) => {
  const lockedAmountZar = getZar8UnlockPositionLockedAmount(selectedPosition);

  if (!selectedPosition) {
    throw new Error("Select an active yield term to continue.");
  }

  if (amountZar <= 0 || amountZar > lockedAmountZar) {
    throw new Error("Unable to submit this unlock request.");
  }

  return create(`api/v2/zar8/positions/${selectedPosition.ledgerId}/unlock`, {
    zar8Amount: amountZar,
    twoFactorToken,
    quote,
  });
};
